import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'lib-ffd-notes-sign-up-modal',
  imports: [TranslatePipe, SvgIconComponent, QRCodeModule],
  templateUrl: './ffd-notes-sign-up-modal.component.html',
  styleUrl: './ffd-notes-sign-up-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesSignUpModalComponent {
  private readonly dialogRef = inject(DialogRef);

  protected readonly qrCodeSize = 200;
  protected readonly logoSize = 22;

  protected onCloseClick(): void {
    this.dialogRef.close();
  }
}
